import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const DELETE_ANIMAL_GROUP = gql`
  mutation DeleteAnimalGroup($domain: String!, $ids: [Int!]!) {
    animalGroup {
      delete(domain: $domain, ids: $ids) {
        code
        success
        message
      }
    }
  }
`

export interface DeleteAnimalGroupResponse {
  animalGroup: {
    delete: Def_MutationResponse
  }
}